<template>
  <div>
    <TitleFrame text="お知らせ" :dense="true">
      <template slot="contents">
        <div class="content-area">
          <div class="tab">
            <div
              class="tab-item"
              :class="{ current: status === 'notify' }"
              @click="onClickNotify"
            >
              お知らせ
            </div>
            <div
              class="tab-item"
              :class="{ current: status === 'news' }"
              @click="onClickNews"
            >
              ニュース
            </div>
          </div>
          <ul v-show="status === 'notify'">
            <li
              v-for="(item, index) in notifydata"
              :key="index"
              @click="onClickNewsItem(item)"
            >
              <p class="title">
                {{ item.title }}
              </p>
              <p class="date">
                {{ formatDate(item.updated_at) }}
              </p>
              <img class="chev" src="@/assets/chevron.svg" />
            </li>
          </ul>
          <ul v-show="status === 'news'">
            <li
              v-for="(item, index) in newsdata"
              :key="index"
              @click="onClickNewsItem(item)"
            >
              <p class="title">
                {{ item.title }}
              </p>
              <p class="date">
                {{ formatDate(item.updated_at) }}
              </p>
              <img class="chev" src="@/assets/chevron.svg" />
            </li>
          </ul>
        </div>
        <div v-if="isDialogOpen" class="background" @click="onClose"></div>
        <div v-if="isDialogOpen" class="dialog">
          <p class="title">
            {{ selectedNotifyItem.title }}
          </p>
          <p>
            {{ selectedNotifyItem.text_content }}
          </p>
          <!-- htmlとして正しい場合のみ動作します。htmlとして正しくない場合はただの文字列になります。 -->
          <!-- 下記のようなデータであれば正しくリンクが動作します -->
          <!-- "<a href='https://www.suisuitabi.org/%E3%82%B9%E3%82%A4%E3%82%B9%E3%82%A4%E6%97%85%E5%B1%B1%E6%A2%A8%E7%89%88'>こちら</a>" -->
          <p v-html="selectedNotifyItem.html_content" />
          <img
            v-for="(item, index) in selectedNotifyItem.images"
            :key="index"
            :src="item.image_url"
          />
          <p class="close">
            <ButtonTextLink
              class="close-button"
              text="閉じる"
              @click-text="onClose"
            />
          </p>
        </div>
      </template>
    </TitleFrame>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import TitleFrame from "@/components/Templates/TitleFrame";
import axios from "axios";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "my-page",
  components: {
    TitleFrame,
    ButtonTextLink,
  },
  data() {
    return {
      selectedNotifyItem: undefined,
      newsdata: [],
      notifydata: [],
      status: "notify",
      text_content: "",
      html_content: "",
      images: [],
      isDialogOpen: false,
    };
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini"]),
    onClickNotify() {
      this.status = "notify";
    },
    onClickNews() {
      this.status = "news";
    },
    onClickNewsItem(val) {
      this.selectedNotifyItem = val;
      this.isDialogOpen = true;
    },
    onClose() {
      this.selectedNotifyItem = undefined;
      this.isDialogOpen = false;
    },
    zeroPaddingTime(val) {
      if (val.toString().length === 1) return `0${val}`;
      return val;
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
  },
  async mounted() {
    this.loadingStartMini();

    await axios
      .get(
        "https://mission-kqxgrnovcq-uc.a.run.app/api/news?api_key=i73rauGTyfewa&registration_id=emqiPRkCnYQ6E7ma1Zwr",
      )
      .then((response) => {
        this.newsdata = response.data;
      });

    await axios
      .get(
        "https://mission-kqxgrnovcq-uc.a.run.app/api/notifications?api_key=i73rauGTyfewa&registration_id=emqiPRkCnYQ6E7ma1Zwr",
      )
      .then((response) => {
        this.notifydata = response.data;
      });
    this.loadingEndMini();
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.content-area {
  height: calc(100% - 6rem);
  overflow: scroll;
}
.tab {
  display: flex;
  color: #d8d8d8;
  .tab-item {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: #e7e7e7 2px solid;
    height: 1.8rem;
    font-size: 1rem;
    font-weight: 700;

    &.current {
      border-bottom: #5cd5d6 2px solid;
      color: #5cd5d6;
    }
  }
}

ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
  li {
    margin: 0;
    display: flex;
    padding: 1rem 2rem 1rem 1rem;
    border-bottom: 1px #e7e7e7 solid;
    position: relative;
    justify-content: space-between;
    align-items: center;

    .title {
      margin: 0;
      width: calc(100vw - 8rem);
      font-size: 0.9rem;
      margin-right: 1rem;
    }
    .date {
      color: #8d8d8d;
      font-size: 0.75rem;
      line-height: 0.75rem;
      height: auto;
    }

    .chev {
      margin-left: 1rem;
      transform: rotate(-90deg);
      height: 0.5rem;
    }
  }
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: calc(100% - 2rem * 2);
  max-height: 80%;
  overflow: scroll;
  padding: 1rem;
  border-radius: 12px;

  p {
    margin: 0.1rem 0;
    word-break: break-all;
  }
  .title {
    text-align: center;
    margin-bottom: 0.5rem;
  }
}

.close {
  margin: 0;

  .close-button {
    margin: 0.5rem 0 0;
  }
}
</style>

<style lang="scss">
.dialog {
  a,
  a:visited,
  a:hover,
  a:active {
    color: #5cd5d6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Notify.vue